<h2 mat-dialog-title>Add accounts</h2>

<mat-dialog-content>
  <p class="hint">
    Creates one persistent account stock per email. Each starts <b>Not ready</b>; the
    fee is the admin-configured default, snapshotted at creation.
    An email that already has an account is reported below and skipped.
  </p>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Supplier</mat-label>
    <mat-select [(ngModel)]="supplierId" [disabled]="running">
      @for (s of suppliers; track s.user_id) {
      <mat-option [value]="s.user_id">{{ s.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Stop threshold (coins)</mat-label>
    <input matInput type="number" min="0" [(ngModel)]="coinsToBeRemain" [disabled]="running">
  </mat-form-field>

  <p class="count">{{ total }} account(s) to add</p>

  @if (running || results.length) {
  <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
  <p class="count">{{ done }} / {{ total }} processed — {{ created }} created</p>
  }

  @if (failed.length) {
  <div class="failures">
    <p class="fail-title"><mat-icon>error_outline</mat-icon> {{ failed.length }} not added</p>
    @for (f of failed; track f.email) {
    <div class="fail-row"><span class="mono">{{ f.email }}</span> — {{ f.reason }}</div>
    }
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" [disabled]="running">Close</button>
  <button mat-flat-button color="primary" [disabled]="running || total === 0" (click)="run()">
    {{ running ? 'Adding…' : 'Add accounts' }}
  </button>
</mat-dialog-actions>
